import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.75 8A6.75 6.75 0 1 1 8 1.25 6.75 6.75 0 0 1 14.75 8Zm-4-.75h-2v-2a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5Z';
const draw24px =
  'M21.75,12A9.75,9.75,0,1,1,12,2.25,9.76,9.76,0,0,1,21.75,12ZM17,11H13V7a1,1,0,0,0-2,0v4H7a1,1,0,0,0,0,2h4v4a1,1,0,0,0,2,0V13h4a1,1,0,0,0,0-2Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PlusCircleFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'plusCircleFilled')) as IconWithRender;

PlusCircleFilledIcon.displayName = 'PlusCircleFilledIcon';
PlusCircleFilledIcon.propTypes = Icon.propTypes;
PlusCircleFilledIcon.renderIcon = (props) => (
  <PlusCircleFilledIcon {...props} />
);
export default PlusCircleFilledIcon;
